import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Components/Main/Header/Header';

const MainLayout = () => {
  return (
    <div>
      <Header />
      <main className="container mt-4">
        <Outlet /> {/* Renders the child route components */}
      </main>
    </div>
  );
};

export default MainLayout;
